import React from 'react'

const CloseButton = (props) => {
  return (
    <span onClick={props.onClick} className={props.className}>&#10005;</span>
  )
}

export default CloseButton